module.exports = __webpack_public_path__ + "img/album01_13.3e452b46.jpg";